<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 mt-2">
      <b-tabs>
        <b-tab
          :title="`${this.$t(
            'menu.settings.accountData.titleListCategoriesGroup',
          )}`"
          active
        >
          <idx-card
            :title="`${this.$t(
              'menu.settings.accountData.titleListCategoriesGroup',
            )}`"
          >
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <input
                    type="text"
                    class="form-control"
                    id="new-category-group"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.newCategoryGroup',
                    )}`"
                  />
                  <button class="btn btn-primary" @click="addCategoryGroup">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="categoryGroups" :fields="groupFields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-categoryGroups-${row.item._id}`"
                        v-model="row.item.active"
                        @change="
                          disableCategoryGroup(row.item._id, row.item.active)
                        "
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-categoryGroups-${row.item._id}`"
                      ></label>
                    </div>
                  </template>
                  <template v-slot:cell(name)="row">
                    <input
                      :id="`edit-group-name-${row.item._id}`"
                      type="text"
                      class="form-control"
                      style="display: none;"
                      :value="row.item.name"
                    />
                    <span
                      :id="`group-name-${row.item._id}`"
                      style="display: block;"
                    >
                      {{ row.item.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="text-center">
                      <button
                        :id="`group-save-${row.item._id}`"
                        class="btn btn-outline-info"
                        @click="saveCategoryGroup(row.item._id)"
                        style="display: none;"
                      >
                        <font-awesome-icon :icon="['fas', 'save']" />
                      </button>
                      <button
                        :id="`group-pen-${row.item._id}`"
                        class="btn btn-outline-primary"
                        @click="editCategoryGroup(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`group-trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteCategoryGroup(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
        <b-tab
          :title="`${this.$t('menu.settings.accountData.titleListCategories')}`"
        >
          <idx-card
            :title="`${this.$t(
              'menu.settings.accountData.titleListCategories',
            )}`"
          >
            <div class="row">
              <div class="col-8">
                <div class="input-area">
                  <label for="selectedGroup">
                    {{ $t('menu.settings.accountData.categoryGroup') }}:
                  </label>
                  <b-select
                    id="selectedGroup"
                    class="col-6 form-control mb-3 ml-3"
                    v-model="selectedGroup"
                    :options="categoryGroupOptions"
                    @change="getCategories"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.selectCategoryGroup',
                    )}`"
                  >
                  </b-select>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <input
                    type="text"
                    class="form-control"
                    id="new-category"
                    :placeholder="`${this.$t(
                      'menu.settings.accountData.newCategory',
                    )}`"
                  />
                  <button class="btn btn-primary" @click="addCategory">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="categories" :fields="fields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-categories-${row.item._id}`"
                        v-model="row.item.active"
                        @change="disableCategory(row.item._id, row.item.active)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-categories-${row.item._id}`"
                      ></label>
                    </div>
                  </template>
                  <template v-slot:cell(name)="row">
                    <input
                      :id="`edit-name-${row.item._id}`"
                      type="text"
                      class="form-control"
                      style="display: none;"
                      :value="row.item.name"
                    />
                    <span :id="`name-${row.item._id}`" style="display: block;">
                      {{ row.item.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="row">
                    <div class="text-center" style="min-width: 200px;">
                      <b-dropdown
                        size="xl"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                      >
                        <template v-slot:button-content>
                          <font-awesome-icon
                            :icon="['fas', 'plus-circle']"
                            class="text-primary"
                            style="cursor: pointer; font-size: 25px;"
                            @click="getSubCategories(row.item._id)"
                          />
                        </template>
                        <span style="padding: 10px;"
                          >{{
                            $t('menu.settings.accountData.addSubCategory')
                          }}:</span
                        >
                        <div style="display: flex; padding: 10px;">
                          <input
                            class="input-subcategories"
                            v-model="subCategory"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'plus-circle']"
                            class="text-primary"
                            style="
                              cursor: pointer;
                              font-size: 25px;
                              margin-left: 5px;
                              margin-top: 5px;
                            "
                            @click="addSubCategory(row.item._id)"
                          />
                        </div>
                      <div class="show-scroll">
                        <b-dropdown-text
                          v-for="(option, i) in options"
                          :key="i"
                          :id="`id-dropdown-${row.item._id}-${i}`"
                        >
                          <div class="my-1 mr-sm-2">
                            <label style="inline-flex" :for="`${row.item._id}-${i}`">
                              <input
                                :id="`edit-subcategory-name-${row.item._id}-${i}`"
                                type="text"
                                class="form-control"
                                style="display: none;"
                                v-model="option.name"
                              />
                                <b-form-checkbox @change="activeSubCategory($event, option)"
                                v-model="option.active" :name="`switch-sub-category-${i}`" switch>
                                </b-form-checkbox>
                                <span
                                  :id="`subcategory-name-${row.item._id}-${i}`"
                                  style="display: block; max-width: 255px;"
                                >
                                  {{ option.name }}
                                </span>
                            </label>
                            <button
                              style="
                                color: red;
                                background: #ffff;
                                border: #fff;
                              "
                              @click="
                                removeSubCategory(row.item._id, option._id)
                              "
                            >
                              x
                            </button>
                            <button
                              :id="`pen-subcategory-${row.item._id}-${i}`"
                              class="btn-subcategory"
                              @click="editSubCategory(i, row.item._id)"
                              style="display: inline;"
                            >
                              <font-awesome-icon :icon="['fas', 'pen']" />
                            </button>
                            <button
                              :id="`subcategory-save-${row.item._id}-${i}`"
                              class="btn btn-outline-info"
                              style="display: none;"
                              @click="
                                saveSubcategory(
                                  i,
                                  option._id,
                                  option.name,
                                  row.item._id,
                                )
                              "
                            >
                              <font-awesome-icon :icon="['fas', 'save']" />
                            </button>
                          </div>
                        </b-dropdown-text>
                      </div>
                      </b-dropdown>
                      <button
                        :id="`save-${row.item._id}`"
                        class="btn btn-outline-info"
                        @click="saveCategory(row.item._id)"
                        style="display: none;"
                      >
                        <font-awesome-icon :icon="['fas', 'save']" />
                      </button>
                      <button
                        :id="`pen-${row.item._id}`"
                        class="btn btn-outline-primary"
                        @click="editCategory(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteCategory(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import api from '../../../services/api';

export default {
  components: { IdxCard },

  data: () => ({
    userAuth: null,
    edit: false,
    categories: [],
    fields: [],
    categoryGroups: [],
    categoryGroupOptions: [],
    groupFields: [],
    selectedGroup: null,
    subCategory: null,
    options: [],
    selected: [],
  }),

  watch: {},

  computed: {},
  methods: {
    // ...mapActions('settings', ['getCategories', 'updateCategories']),

    async activeSubCategory(active, itensSubCategory){
      await api.put(
        `/update-subcategories/${itensSubCategory._id}`,
        {
          active,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      swal({
        title: 'Sucesso',
        text:
          'O status da sub categoria foi alterado com sucesso!',
        icon: 'success'
      })
    },

    async saveSubcategory(index, idSubcategory, value, category) {
      const $input = document.getElementById(
        `edit-subcategory-name-${category}-${index}`,
      );
      $input.style.display = 'none';
      document.getElementById(
        `subcategory-name-${category}-${index}`,
      ).style.display = 'block';
      document.getElementById(
        `subcategory-save-${category}-${index}`,
      ).style.display = 'none';
      document.getElementById(
        `pen-subcategory-${category}-${index}`,
      ).style.display = 'inline';
      document.getElementById(`id-dropdown-${category}-${index}`).style.width =
        '300px';

      await api.put(
        `/update-subcategories/${idSubcategory}`,
        {
          subCategoryName: value,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      // swal({
      //   title: this.$t(
      //     'menu.settings.accountData.messages.updatedSubCategory.title',
      //   ),
      //   text: this.$t(
      //     'menu.settings.accountData.messages.updatedSubCategory.description',
      //   ),
      //   icon: 'success',
      // });
    },

    async removeSubCategory(mainCategoryId, subCategoryId) {
      swal({
        title: this.$t('menu.settings.accountData.subCategory.removeTitle'),
        text: this.$t(
          'menu.settings.accountData.subCategory.removeDescription',
        ),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.accountData.subCategory.cancelDescription'),
          this.$t('menu.settings.accountData.subCategory.deleteDescription'),
        ],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/subcategories/${subCategoryId}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });

          this.getSubCategories(mainCategoryId);

          swal({
            title: this.$t(
              'menu.settings.accountData.subCategory.successTitle',
            ),
            text: this.$t(
              'menu.settings.accountData.subCategory.successDescription',
            ),
            icon: 'success',
          });
        }
      });
    },

    async addSubCategory(mainCategoryId) {
      await api.post(
        '/add-subcategories',
        {
          subCategory: this.subCategory,
          mainCategoryId,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.subCategory = null;

      this.getSubCategories(mainCategoryId);
    },

    async getSubCategories(categoryId) {
      try {
        const response = await api.get(`/config-subcategories/${categoryId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.options = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    async getCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: this.selectedGroup,
          },
        });
        this.categories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    async addCategory() {
      const $input = document.getElementById('new-category');
      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.categories.length; i += 1) {
          if (this.categories[i].name === newName) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.title',
              ),
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.description',
              ),
              'error',
            );
            return;
          }
        }
        try {
          await api.post(
            '/categories',
            {
              name: newName,
              categoryGroupId: this.selectedGroup,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            this.$t('menu.settings.accountData.messages.createdCategory.title'),
            this.$t(
              'menu.settings.accountData.messages.createdCategory.description',
            ),
            'success',
          );
          await this.getCategories();
        } catch (error) {
          window.console.log(error);
        }
        $input.value = '';
      }
    },

    async disableCategory(id, active) {
      try {
        await api.patch(
          `/categories/${id}`,
          { active },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        swal(
          this.$t('menu.settings.accountData.messages.updatedCategory.title'),
          this.$t(
            'menu.settings.accountData.messages.updatedCategory.description',
          ),
          'success',
        );
        await this.getCategories();
      } catch (error) {
        window.console.log(error);
      }
    },
    async deleteCategory(id) {
      swal({
        title: this.$t('menu.settings.accountData.category.removeTitle'),
        text: this.$t('menu.settings.accountData.category.removeDescription'),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.accountData.category.cancelDescription'),
          this.$t('menu.settings.accountData.category.deleteDescription'),
        ],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/categories/${id}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });

          this.getCategories();

          swal({
            title: this.$t('menu.settings.accountData.category.successTitle'),
            text: this.$t(
              'menu.settings.accountData.category.successDescription',
            ),
            icon: 'success',
          });
        }
      });
    },
    editCategory(index) {
      document.getElementById(`edit-name-${index}`).style.display = 'block';
      document.getElementById(`name-${index}`).style.display = 'none';
      document.getElementById(`save-${index}`).style.display = 'inline';
      document.getElementById(`trash-${index}`).style.display = 'none';
      document.getElementById(`pen-${index}`).style.display = 'none';
    },

    editSubCategory(index, category) {
      document.getElementById(`id-dropdown-${category}-${index}`).style.width =
        '450px';
      document.getElementById(
        `edit-subcategory-name-${category}-${index}`,
      ).style.display = 'block';
      document.getElementById(
        `subcategory-name-${category}-${index}`,
      ).style.display = 'none';
      document.getElementById(
        `subcategory-save-${category}-${index}`,
      ).style.display = 'inline';
      document.getElementById(
        `pen-subcategory-${category}-${index}`,
      ).style.display = 'none';
    },

    async saveCategory(index) {
      const $input = document.getElementById(`edit-name-${index}`);
      $input.style.display = 'none';
      document.getElementById(`name-${index}`).style.display = 'block';
      document.getElementById(`save-${index}`).style.display = 'none';
      document.getElementById(`trash-${index}`).style.display = 'inline';
      document.getElementById(`pen-${index}`).style.display = 'inline';

      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.categories.length; i += 1) {
          if (
            this.categories[i].name === newName &&
            this.categories[i]._id !== index
          ) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.title',
              ),
              this.$t(
                'menu.settings.accountData.messages.duplicatedCategory.description',
              ),
              'error',
            );
            $input.value = '';
            return;
          }
        }
        try {
          await api.patch(
            `/categories/${index}`,
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            this.$t('menu.settings.accountData.messages.updatedCategory.title'),
            this.$t(
              'menu.settings.accountData.messages.updatedCategory.description',
            ),
            'success',
          );
          await this.getCategories();
        } catch (error) {
          window.console.log(error);
        }
      }
    },
    async getCategoryGroups() {
      try {
        const response = await api.get('/category-groups', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categoryGroups = response.data;
        this.categoryGroupOptions = [];
        for (let i = 0; i < this.categoryGroups.length; i += 1) {
          this.categoryGroupOptions.push({
            text: this.categoryGroups[i].name,
            value: this.categoryGroups[i]._id,
          });
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async addCategoryGroup() {
      const $input = document.getElementById('new-category-group');
      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.categoryGroups.length; i += 1) {
          if (this.categoryGroups[i].name === newName) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedGroup.title',
              ),
              this.$t(
                'menu.settings.accountData.messages.duplicatedGroup.description',
              ),
              'error',
            );
            return;
          }
        }
        try {
          await api.post(
            '/category-groups',
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            this.$t('menu.settings.accountData.messages.createdGroup.title'),
            this.$t(
              'menu.settings.accountData.messages.createdGroup.description',
            ),
            'success',
          );
          await this.getCategoryGroups();
        } catch (error) {
          window.console.log(error);
        }
        $input.value = '';
      }
    },
    async disableCategoryGroup(id, active) {
      try {
        await api.patch(
          `/category-groups/${id}`,
          { active },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        swal(
          this.$t('menu.settings.accountData.messages.updatedGroup.title'),
          this.$t(
            'menu.settings.accountData.messages.updatedGroup.description',
          ),
          'success',
        );
        await this.getCategoryGroups();
      } catch (error) {
        window.console.log(error);
      }
    },
    async deleteCategoryGroup(id) {
      try {
        await api.delete(`/category-groups/${id}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        swal(
          this.$t('menu.settings.accountData.messages.deletedGroup.title'),
          this.$t(
            'menu.settings.accountData.messages.deletedGroup.description',
          ),
          'success',
        );
        await this.getCategoryGroups();
      } catch (error) {
        window.console.log(error);
      }
    },
    editCategoryGroup(index) {
      document.getElementById(`edit-group-name-${index}`).style.display =
        'block';
      document.getElementById(`group-name-${index}`).style.display = 'none';
      document.getElementById(`group-save-${index}`).style.display = 'inline';
      document.getElementById(`group-trash-${index}`).style.display = 'none';
      document.getElementById(`group-pen-${index}`).style.display = 'none';
    },
    async saveCategoryGroup(index) {
      const $input = document.getElementById(`edit-group-name-${index}`);
      $input.style.display = 'none';
      document.getElementById(`group-name-${index}`).style.display = 'block';
      document.getElementById(`group-save-${index}`).style.display = 'none';
      document.getElementById(`group-trash-${index}`).style.display = 'inline';
      document.getElementById(`group-pen-${index}`).style.display = 'inline';
      const newName = $input.value;
      if (newName !== '') {
        for (let i = 0; i < this.categoryGroups.length; i += 1) {
          if (
            this.categoryGroups[i].name === newName &&
            this.categoryGroups[i]._id !== index
          ) {
            swal(
              this.$t(
                'menu.settings.accountData.messages.duplicatedGroup.title',
              ),
              this.$t(
                'menu.settings.accountData.messages.duplicatedGroup.description',
              ),
              'error',
            );
            $input.value = '';
            return;
          }
        }
        try {
          await api.patch(
            `/category-groups/${index}`,
            {
              name: newName,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            this.$t('menu.settings.accountData.messages.updatedGroup.title'),
            this.$t(
              'menu.settings.accountData.messages.updatedGroup.description',
            ),
            'success',
          );
          await this.getCategoryGroups();
        } catch (error) {
          window.console.log(error);
        }
      }
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getCategoryGroups();
    await this.getSubCategories();

    /*
    this.getCategories({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    }).then(() => {
      this.categories = this.companyCategories;
    });
    */
  },
  created() {
    this.fields = [
      {
        key: 'active',
        label: this.$t('menu.settings.accountData.labels.active'),
        sortable: true,
      },
      {
        key: 'name',
        label: this.$t('menu.settings.accountData.labels.name'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('menu.settings.accountData.labels.action'),
      },
    ];
    this.groupFields = [
      {
        key: 'active',
        label: this.$t('menu.settings.accountData.labels.active'),
        sortable: true,
      },
      {
        key: 'name',
        label: this.$t('menu.settings.accountData.labels.name'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('menu.settings.accountData.labels.action'),
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.show-scroll {
  max-height: 400px;
  overflow: auto;
}

label {
  display: inline-flex;
}

.b-dropdown-text {
  display: inline-block;
  padding: .25rem 1.5rem;
  margin-bottom: 0;
  width: 400px;
  clear: both;
  font-weight: lighter;
}

.btn-subcategory {
  border: none;
  font-size: 12px;
  color: #4ce595;
  background: #fff;
}

.input-area {
  display: flex;
  flex-direction: row;
}

.header {
  background-color: #72bcd4;
  color: #fff;
  padding: 10px 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.body {
  padding: 20px 0;
  border: 1px solid #ccc;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
select.custom-select.no-select-caret {
  background-image: none !important;
}

.input-subcategories {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: 5px;
  width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/add-categories/index.vue